import { useAndStore, parseAction } from "@nuwatop/code-canvas-core";

export interface ActionContext {
  sessionId: string;
  componentId?: string;
  dataSet?: string;
  value?: any;
  event?: any;
}

export interface ActionHandler {
  (context: ActionContext, ...args: any[]): Promise<any> | any;
}

// 内置动作处理器
const builtinHandlers = new Map<string, ActionHandler>();

/**
 * 注册动作处理器
 */
export const registerActionHandler = (name: string, handler: ActionHandler) => {
  builtinHandlers.set(name, handler);
};

/**
 * 执行动作
 */
export const executeAction = async (
  actionString: string,
  context: ActionContext
): Promise<any> => {
  const { actionName, arg } = parseAction(actionString, context.value);

  // 查找处理器
  const handler = builtinHandlers.get(actionName);

  if (handler) {
    return handler(context, arg);
  }

  // 默认行为：添加到命令队列
  const addCommand = useAndStore.getState().addCommand;
  addCommand(context.sessionId, {
    actionName,
    arg,
    timestamp: Date.now(),
  });

  return { actionName, arg };
};

// 内置动作
registerActionHandler("setDataSet", (context, arg) => {
  const { setDataSet } = useAndStore.getState();
  if (arg?.dataSet && arg?.field !== undefined) {
    setDataSet(arg.dataSet, arg.field, arg.value);
  }
});

registerActionHandler("navigate", (context, arg) => {
  if (typeof window !== "undefined" && arg?.url) {
    if (arg.target === "_blank") {
      window.open(arg.url, "_blank");
    } else {
      window.location.href = arg.url;
    }
  }
});

registerActionHandler("alert", (context, arg) => {
  if (typeof window !== "undefined") {
    window.alert(arg?.message || arg);
  }
});

registerActionHandler("console", (context, arg) => {});

/**
 * ActionExecutor 对象
 */
export const ActionExecutor = {
  execute: executeAction,
  register: registerActionHandler,
  hasHandler: (name: string) => builtinHandlers.has(name),
};

export default ActionExecutor;
